import React from 'react';
import { cn } from '@/shared/utils/style/cn';

export default function PageContainer({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className="relative h-[100vh] w-full">
      <div
        className={cn(
          'flex h-full w-full flex-1 flex-col overflow-x-hidden',
          'has-[#header]:pt-[48px]',
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
